__turbopack_context__.v({
  "className": "jetbrains_mono_db1d8880-module__eijGNG__className",
  "variable": "jetbrains_mono_db1d8880-module__eijGNG__variable",
});
